<template>
  <div class="card mt-3 w-100 mx-auto" v-on:click="selectAddress()">
    <div class="card-body">
      <h5 class="card-title">{{ address.tib.name }}</h5>
      <p class="card-text" v-if="!isEmptyString(address.data.address)">
        {{ address.data.address }}, {{ address.data.city }}
      </p>
      <div class="md" v-html="markedHtml(address.data.description)"></div>
    </div>
  </div>
</template>

<script>
import { isEmptyString, markedHtml } from "@/common/utils";
export default {
  name: "addressItem",
  data() {
    return {
      address: this.addressProperty,
      isEmptyString: isEmptyString,
      markedHtml: markedHtml
    };
  },
  methods: {
    selectAddress() {
      console.info("selectAddress");
      console.info("emit:selectaddress");
      this.$emit("selectaddress", this.address);
    }
  },
  props: ["addressProperty", "newTibTagProperty"]
};
</script>
